import React from 'react';

interface MenuItemsProps {
  dashboardTitles: (string | undefined)[];
  selectedDashboardIndex: number;
  setSelectedDashboardIndex: Function;
}

export function MenuItems({
  dashboardTitles,
  selectedDashboardIndex,
  setSelectedDashboardIndex,
}: MenuItemsProps) {
  return (
    <>
      {dashboardTitles.map((dashboard, index) => (
        <li
          key={index}
          onClick={() => setSelectedDashboardIndex(index)}
          className={'umb-tree-item ' + (index === selectedDashboardIndex ? ' current' : '')}
        >
          <div className={'umb-tree-item__inner pad-left'}>
            <span className={'icon umb-tree-icon umb-icon'}>
              <span className={'umb-icon__inner'}>
                <i className={'fas fa-chart-column'}></i>
              </span>
            </span>
            <a className={'umb-tree-item__label'}>{dashboard ?? `Dashboard ${index + 1}`}</a>
          </div>
        </li>
      ))}
    </>
  );
}
